// extracted by mini-css-extract-plugin
export var baseButton = "_ow-0";
export var controlsArrowKeys = "_ow-1";
export var controlsResetButton = "_ow-2";
export var lightGameButton = "_ow-4 _ow-0";
export var playAgainButton = "_ow-5 _ow-0";
export var startGameButton = "_ow-3 _ow-0";